<template>
  <div>

    <dialog-edit-contact icon="mdi-pencil" btn_color="primary" title="Editar"></dialog-edit-contact>
    <contact-form :contact="contact" read_only></contact-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {mask} from 'vue-the-mask'

export default {
  name: 'ShowModalityContact',
  directives: {mask},
  components: {
    DialogEditContact: () => import('../register/edit/DialogEditContact'),
    ContactForm: () => import('@/_backoffice/_registrations/components/shared/forms/ContactForm.vue'),
  },
  props: {
    contact: {
      type: Object,
    },
  },
  data() {
    return {
    }
  },
  methods: {
  },
  computed: {
    ...mapState({
      one_modality: state => state.Modality.one_modality
    })
  },
  watch: {
  },
}
</script>
